const BASE_HTTP_URL = 'https://api.prod.heartbits.me'

const Urls = {
  baseHttpUrl: BASE_HTTP_URL,
  getDetailsUrl: BASE_HTTP_URL + '/receptionist/get-details',
  saveDetailsUrl: BASE_HTTP_URL + '/receptionist/set-details'
}

export default Urls
